module.exports = "<p>\r\n  parameter works!\r\n</p>\r\n"